import {ABILITY_GRUNG_POISON_SKIN} from '@/constants/creatureAbilityList'
import {CREATURE_GRUNG} from '@/constants/creatureIdList'
import {faTint} from '@fortawesome/free-solid-svg-icons'

import grungPoisonSkinPostText from './constants/grungPoisonSkinPostText'

export default {
  templateName: 'Яд синего грунга',
  templateIcon: faTint,
  templateColor: 'blue',
  templateLimitations: {
    include: {
      id: [
        CREATURE_GRUNG,
      ],
    },
  },

  name: 'Синий грунг',

  editPropCollection: {
    featureList: ({ featureList }) => featureList.map(
      feature => feature.id === ABILITY_GRUNG_POISON_SKIN
        ? {
          ...feature,
          name: `${feature.name} синего грунга`,
          description: `${feature.description} ${grungPoisonSkinPostText}`.replace(
            `Отравленное существо`,
            'Отравленное существо громко кричит или издает громкие звуки в начале и конце своего хода. Отравленное существо'
          )
        }
        : feature,
    ),
  },
}
